import React, { useRef } from "react";
import HomeHero from '../features/homeHero/HomeHero';
import "../animations.css";
import AnimateSection from "../features/animateSection/AnimateSection";

export default function Home() {

    const sectionRef = useRef(null);


    return (
        <AnimateSection>
            <HomeHero />
        </AnimateSection>
    );
}